import { LegalSection } from "#app/components/sections/legal.js";

export const handle = {
	i18n: "legal",
};

export default function GuidelinesPage() {
	return (
		<>
			<LegalSection />
		</>
	);
}
